<h5 class="my-3 mt-lg-5 text-capitalize">FastEntry (facial recognition)</h5>
<div class="shadow rounded status-card p-3 bg-primary d-flex flex-column">
  <p class="font-size-12 text-white">
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. consectetur adipiscing elit amet.
    <span class="font-weight-bold">See more</span>
  </p>
  <ng-container *ngIf="identityVerified$ | async as identityVerified; else userNotFound">
    <!--User verified-->
    <ng-container *ngIf="identityVerified.identityVerificationStatus; else notVerified">
      <div class="mx-auto mt-auto">
        <div class="d-flex">
          <img
            alt="Verification Successful"
            class="verified-icon mr-2"
            src="assets/images/icons/gbg-verified-id.svg"
            draggable="false"
          />
          <p class="success-text font-weight-bold font-size-14 my-auto">FastEntry Active (facial recognition)</p>
        </div>
      </div>
    </ng-container>
    <!--User not verified-->
    <ng-template #notVerified>
      <button class="btn btn-white text-primary font-weight-bold font-size-14 mx-auto mt-auto" (click)="ssoToGbg()">
        Register for FastEntry to Dodgers Stadium
      </button>
    </ng-template>
  </ng-container>
  <!--User not found-->
  <ng-template #userNotFound>
    <div class="mx-auto mt-auto">
      <div class="d-flex">
        <img alt="Verification Failed" class="verified-icon mr-2" src="assets/images/icons/gbg-not-found.svg" draggable="false" />
        <p class="text-danger font-weight-bold font-size-14 my-auto">Unable to find account</p>
      </div>
    </div>
  </ng-template>
</div>
